import { render } from "./RotaModal.vue?vue&type=template&id=91b75fb2&scoped=true"
import script from "./RotaModal.vue?vue&type=script&lang=js"
export * from "./RotaModal.vue?vue&type=script&lang=js"

import "./RotaModal.vue?vue&type=style&index=0&id=91b75fb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b75fb2"]])

export default __exports__